/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tx-location-select.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../../app/shared/component/tx-location-select/tx-location-select.component';
import * as i4 from 'angular2-materialize/dist/materialize-directive';
import * as i5 from '@angular/common';
const styles_TxLocationSelectComponent:any[] = [i0.styles];
export const RenderType_TxLocationSelectComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TxLocationSelectComponent,data:{}});
function View_TxLocationSelectComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'option',[['disabled',
      ''],['selected','']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(1,147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,
      i1.Renderer2,[8,(null as any)]],(null as any),(null as any)),i1.ɵdid(2,147456,
      (null as any),0,i2.ɵq,[i1.ElementRef,i1.Renderer2,[8,(null as any)]],(null as any),
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['Selecione um']))],(null as any),
      (null as any));
}
function View_TxLocationSelectComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'option',[['disabled',
      ''],['selected','']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(1,147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,
      i1.Renderer2,[8,(null as any)]],(null as any),(null as any)),i1.ɵdid(2,147456,
      (null as any),0,i2.ɵq,[i1.ElementRef,i1.Renderer2,[8,(null as any)]],(null as any),
      (null as any)),(_l()(),i1.ɵted(3,(null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.selectedLocation;
    _ck(_v,3,0,currVal_0);
  });
}
function View_TxLocationSelectComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'option',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(1,
      147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,i1.Renderer2,[8,(null as any)]],
      {value:[0,'value']},(null as any)),i1.ɵdid(2,147456,(null as any),0,i2.ɵq,[i1.ElementRef,
      i1.Renderer2,[8,(null as any)]],{value:[0,'value']},(null as any)),(_l()(),i1.ɵted(3,
      (null as any),['\n    ','\n  ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_2);
  });
}
export function View_TxLocationSelectComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),11,'select',[['materialize',
      'material_select'],['name','selectedLocation']],(null as any),[[(null as any),
      'change']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.TxLocationSelectComponent = _v.component;
    if (('change' === en)) {
      const pd_0:any = ((<any>_co.emitLocationName($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(1,5128192,(null as any),0,i4.MaterializeDirective,
      [i1.ElementRef],{materialize:[0,'materialize'],materializeSelectOptions:[1,'materializeSelectOptions']},
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_TxLocationSelectComponent_1)),
      i1.ɵdid(4,16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxLocationSelectComponent_2)),
      i1.ɵdid(7,16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxLocationSelectComponent_3)),
      i1.ɵdid(10,802816,(null as any),0,i5.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵeld(13,0,(null as any),(null as any),1,'label',([] as any[]),(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(14,
          (null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,
      _v) => {
    var _co:i3.TxLocationSelectComponent = _v.component;
    const currVal_0:any = 'material_select';
    const currVal_1:any = _co.locations;
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_2:boolean = !_co.selectedLocation;
    _ck(_v,4,0,currVal_2);
    const currVal_3:any = _co.selectedLocation;
    _ck(_v,7,0,currVal_3);
    const currVal_4:any = _co.locations;
    _ck(_v,10,0,currVal_4);
  },(_ck,_v) => {
    var _co:i3.TxLocationSelectComponent = _v.component;
    const currVal_5:any = _co.label;
    _ck(_v,14,0,currVal_5);
  });
}
export function View_TxLocationSelectComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'tx-location-select',
      ([] as any[]),(null as any),(null as any),(null as any),View_TxLocationSelectComponent_0,
      RenderType_TxLocationSelectComponent)),i1.ɵdid(1,114688,(null as any),0,i3.TxLocationSelectComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TxLocationSelectComponentNgFactory:i1.ComponentFactory<i3.TxLocationSelectComponent> = i1.ɵccf('tx-location-select',
    i3.TxLocationSelectComponent,View_TxLocationSelectComponent_Host_0,{geonameId:'geonameId',
        label:'label',selectedLocation:'selectedLocation'},{txLocationName:'txLocationName'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-location-select/tx-location-select.component.ngfactory.ts